import { default as applicationLogic } from './application/logic';
import { default as authenticationLogic } from './authentication/logic';
import { default as alertLogic } from './alert/logic';
import { default as resetStateLogic } from './resetState/logic';
import { default as navigationLogic } from './navigation/logic';
import { default as stayRatingLogic } from './stayRating/logic';

export default [...applicationLogic, ...authenticationLogic, ...alertLogic, ...resetStateLogic, ...navigationLogic, ...stayRatingLogic];
